import { BusinessDownloadConfig } from '../types';
import { newPublisherCheckboxList } from './common';

const mobileDetailsConfig: BusinessDownloadConfig = {
  'mobile-stats-retentionmonthly': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: [],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: [],
        options: [
          { label: 'dbi_active_users', value: 'au' },
          { label: 'dbi_revenue', value: 'rv' },
          { label: 'dbi_downloads', value: 'dl' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_monthly_retention', value: 'mr' },
          {
            label: 'dbi_lifetime_retention',
            value: 'lr',
            message: 'dbi_lifetime_retention_tips',
          },
          { label: 'RPD', value: 'rp' },
          { label: 'dbi_metric_cumulative_revenue', value: 'cr' },
          { label: 'dbi_metric_cumulative_downloads', value: 'cd' },
          { label: 'Hours Watched', value: 'hw' },
          { label: 'Airtime', value: 'at' },
          { label: 'Peak CCV', value: 'pk' },
          { label: 'Avg CCV', value: 'ac' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message: 'dbi_label_time_settings_tips',
            defaultValue: ['monthly'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-stats-retentionlifetime': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: [],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: [],
        options: [
          { label: 'dbi_active_users', value: 'au' },
          { label: 'dbi_revenue', value: 'rv' },
          { label: 'dbi_downloads', value: 'dl' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_monthly_retention', value: 'mr' },
          {
            label: 'dbi_lifetime_retention',
            value: 'lr',
            message: 'dbi_lifetime_retention_tips',
          },
          { label: 'RPD', value: 'rp' },
          { label: 'dbi_metric_cumulative_revenue', value: 'cr' },
          { label: 'dbi_metric_cumulative_downloads', value: 'cd' },
          { label: 'Hours Watched', value: 'hw' },
          { label: 'Airtime', value: 'at' },
          { label: 'Peak CCV', value: 'pk' },
          { label: 'Avg CCV', value: 'ac' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'edition',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message: 'dbi_label_time_settings_tips',
            defaultValue: ['monthly'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-stats-countries': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: ['au'],
        options: [
          { label: 'dbi_active_users', value: 'au' },
          { label: 'dbi_revenue', value: 'rv' },
          { label: 'dbi_downloads', value: 'dl' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_monthly_retention', value: 'mr' },
          {
            label: 'dbi_lifetime_retention',
            value: 'lr',
            message: 'dbi_lifetime_retention_tips',
          },
          { label: 'RPD', value: 'rp' },
          { label: 'dbi_metric_cumulative_revenue', value: 'cr' },
          { label: 'dbi_metric_cumulative_downloads', value: 'cd' },
          { label: 'Hours Watched', value: 'hw' },
          { label: 'Airtime', value: 'at' },
          { label: 'Peak CCV', value: 'pk' },
          { label: 'Avg CCV', value: 'ac' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message: 'dbi_label_time_settings_tips',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
        ],
      },
    ],
    getFormList: (tableParams: any) => {
      return getMobileStatsCountriesFormList(tableParams);
    },
  },
  'mobile-stats-countries-rpd': {
    apiUrl: 'api/v1/intelligence_pc/detail/stats/metrics/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: ['au'],
        options: [
          { label: 'dbi_active_users', value: 'au' },
          { label: 'dbi_revenue', value: 'rv' },
          { label: 'dbi_downloads', value: 'dl' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_monthly_retention', value: 'mr' },
          {
            label: 'dbi_lifetime_retention',
            value: 'lr',
            message: 'dbi_lifetime_retention_tips',
          },
          { label: 'RPD', value: 'rp' },
          { label: 'dbi_metric_cumulative_revenue', value: 'cr' },
          { label: 'dbi_metric_cumulative_downloads', value: 'cd' },
          { label: 'Hours Watched', value: 'hw' },
          { label: 'Airtime', value: 'at' },
          { label: 'Peak CCV', value: 'pk' },
          { label: 'Avg CCV', value: 'ac' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message: 'dbi_label_time_settings_tips',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-details-store-rank': {
    apiUrl: '/api/v1/intelligence_pc/detail/stats/metrics/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'source_type',
        defaultValue: ['app_store', 'google_play'],
        options: [
          { label: 'App Store', value: 'app_store' },
          { label: 'Google Play', value: 'google_play' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message: '',
            options: [{ label: 'dbi_label_separate_by_time_combine', value: 'separate' }],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'market',
            options: [
              // { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-details-store-rank-trend': {
    apiUrl: '/api/v1/intelligence_pc/mobile/detail/stats/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'source_type',
        defaultValue: ['app_store', 'google_play'],
        options: [
          { label: 'App Store', value: 'app_store' },
          { label: 'Google Play', value: 'google_play' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_edition', value: 'edition' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message: '',
            options: [{ label: 'dbi_label_separate_by_time_combine', value: 'separate' }],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'market',
            options: [
              // { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-detail-demographics': {
    apiUrl: 'api/v1/intelligence_pc/detail/demographicsExcel',
    bubbleText: '',
    translate: true,
    formList: [],
  },
};

const getMobileStatsCountriesFormList = (tableParams: any = {}) => {
  const currentFormList = mobileDetailsConfig['mobile-stats-countries'].formList || [];

  if (tableParams?.segment !== 'revenue') {
    return currentFormList;
  }

  return currentFormList.map((item) => {
    if (item?.field !== 'metric') {
      return item;
    }

    return {
      ...item,
      options: item?.options?.map((option) => {
        if (option?.value !== 'rv') {
          return option;
        }

        return {
          ...option,
          message: 'dbi_download_settings_revenue_scope_tip',
        };
      }),
    };
  });
};

export default mobileDetailsConfig;
